<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>
    <a-modal v-model="geoshow"  >
      <MapGeo @mapgeoEvent="SaveMapEvent"  :keyWord="address"></MapGeo>
    </a-modal>
    <a-card class="all-card-style ">

      <a-form-model :model="scene"  :rules="sceneFormRules" ref="scene"   :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" >
        <a-row>
        <a-col :span="8">
          <a-form-model-item label="类型"  class="ant-form-item2 " >
            <a-select
              placeholder=""
              v-model="scene.iTypeID"  @change="iTypeIDSelectFun"    class="ant-form-item3 "
            >


              <a-select-option value="4" >
                场景图4
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        </a-row>


        <a-row>
          <a-col :span="8">
            <a-form-model-item label="设备"  prop="cSceneCode"  class="ant-form-item2 " >
              <a-select v-model="sb1" @change="deviceSelect1"   class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in deviceGFJSelectItems" :value="item.ID">
                  {{item.DeviceAsName}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item label="风扇1"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq1" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems1" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item label="风扇2"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq2" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems2" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="警报器"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq3" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems3" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="通风窗1"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq4" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems4" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="通风窗2"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq5" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems5" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="灯光"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq6" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems6" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="测通风窗"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq8" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems8" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="风机"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq9" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems9" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="加热设备"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq10" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems10" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="除湿机"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq11" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems11" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==6666664">
          <a-col :span="8">
            <a-form-model-item  label="湿帘"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq12" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems12" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="CO2补气"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq13" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems13" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="喷淋1"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq7" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems7" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row  v-show="scene.iTypeID==4">
          <a-col :span="8">
            <a-form-model-item  label="喷淋2"  prop="cSceneCode"  class="ant-form-item2 " >

              <a-select v-model="zxq14" class="ant-form-item3"  >
                <a-select-option v-for="(item,index) in controllerSelectItems14" :value="item.ID">
                  {{item.name}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>

        </a-form-model-item>

      </a-form-model>

<div v-show="iTypeIDSelectId==1">
  <img src="../../../img/smap1.png" style="width: 900px;" />

</div>

      <div v-show="iTypeIDSelectId==2">
        <img src="../../../img/smap2.png" style="width: 900px;" />

      </div>
      <div v-show="iTypeIDSelectId==3">
        <img src="../../../img/smap3.png" style="width: 900px;" />

      </div>
      <div v-show="iTypeIDSelectId==4">
        <img src="../../../img/smap4.png" style="width: 1000px;" />

      </div>
    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import MapGeo from '@/components/MapGeo'
  export default {
    name: 'sceneManagementForm',
    components: {
      TitleCard,
      MapGeo
    },
    data() {
      return {
        options:[],
        dfi:['110000','110100','110101'],
        sceneFormRules:{

        },
        titleMsg1: "设备管理",
        titleMsg2:'场地管理',
        titleMsg3:'场景图管理',
        titleMsg4:'新增',
        scene:{
          ID:"",
          cEntID:"",
          cPlatformID:"",
          cSceneTempID:"",
          cSceneCode:"",
          cSceneName:"",
          cAddress:"",
          cLatitude:"",
          cLongitude:"",
          cArea:"",
          cUnit:"",
          cVariety:"",
          cChargeUser:"",
          cChargeMoblie:"",
          cChargeEmail:"",
          iDelete:"",
          cCreateUserID:"",
          cCreateUserName:"",
          dCreateDate:"",
          cUpdateUserID:"",
          cUpdateUserName:"",
          Remark:""
        },
        cVarietyClass:"",
        unitList:[],
        varietyList:[],
        userList:[],
        varietyclassList:[],
        PlatformList:[],
        PlatformCurrent:{},
        address:"",
        deviceGFJSelectItems:[],
        deviceJXGLQSelectItems:[],
        deviceSBSelectItems:[],
        deviceSBOSelectItems:[],
        deviceZWXSelectItems:[],
        geoshow:false,
        controllerSelectItems1:[],
        controllerSelectItems2:[],
        controllerSelectItems3:[],
        controllerSelectItems4:[],
        controllerSelectItems5:[],
        controllerSelectItems6:[],
        controllerSelectItems7:[],
        controllerSelectItems8:[],
        controllerSelectItems9:[],
        controllerSelectItems10:[],
        controllerSelectItems11:[],
        controllerSelectItems12:[],
        controllerSelectItems13:[],
        controllerSelectItems14:[],
        sb1:'',
        zxq1:'',

        sb2:'',
        zxq2:'',

        sb3:'',
        zxq3:'',

        sb4:'',
        zxq4:'',

        sb5:'',
        zxq5:'',

        sb6:'',
        sb7:'',
        sb8:'',
        sb9:'',
        sb10:'',
        sb11:'',
        sb12:'',
        sb13:'',
        sb14:'',
        sb15:'',


        zxq6:'',
        zxq7:'',
        zxq8:'',
        zxq9:'',
        zxq10:'',
        zxq11:'',
        zxq13:'',
        zxq12:'',
        zxq14:'',
        zxq16:'',
        zxq15:'',
        iTypeIDSelectId:-1,
        SceneInfoID:'',
      }
    },
    mounted () {
      let that=this;

      console.log('that.$route.params.ID',that.$route.params.ID);
      if (that.$route.params.ID){
        that.scene.SceneInfoID=that.$route.params.ID;
        that.SceneInfoID=that.$route.params.ID;
        that.HandleDetail();
      }
      try{   that.dfi=[ that.scene.cEntCountry+'', that.scene.cEntCity+'', that.scene.cEntArea+''];}catch (e) {

      }

      that.handleunit();
      that.handlusers();

      that.handlePageList();
      that.getDeviceIDSelectItems();
    },
    methods: {
      iTypeIDSelectFun(obj){
console.log('obj:::',obj);
        this.iTypeIDSelectId=obj;

      },
      async deviceSelect1(obj){
        console.log('obj::::::',obj);

//controllerGFJSelectItems
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerSelectItems1=res.data.obj.list;
          that.controllerSelectItems2=res.data.obj.list;
          that.controllerSelectItems3=res.data.obj.list;
          that.controllerSelectItems4=res.data.obj.list;
          that.controllerSelectItems5=res.data.obj.list;
          that.controllerSelectItems6=res.data.obj.list;
          that.controllerSelectItems7=res.data.obj.list;
          that.controllerSelectItems8=res.data.obj.list;
          that.controllerSelectItems9=res.data.obj.list;
          that.controllerSelectItems10=res.data.obj.list;
          that.controllerSelectItems11=res.data.obj.list;
          that.controllerSelectItems12=res.data.obj.list;
          that.controllerSelectItems13=res.data.obj.list;
          that.controllerSelectItems14=res.data.obj.list;

        }
      },
      async deviceJXGLQSelect(obj){
//controllerJXGLSelectItems
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerJXGLSelectItems=res.data.obj.list;
        }
      },
      async deviceSBSelect(obj){
//controllerSBSelectItems
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerSBSelectItems=res.data.obj.list;
        }
      },
      async deviceSBOSelect(obj){
//controllerSBOSelectItems
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerSBOSelectItems=res.data.obj.list;
        }
      },
      async deviceZWXSelect(obj){
//controllerZWXSelectItems.
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+obj,{});
        if(res.data.code=='200'){
          that.controllerZWXSelectItems=res.data.obj.list;


        }
      },

      async getDeviceIDSelectItems(){
        let that=this;
        let res = await this.$http.post('WLWDevice/List', {
          cEntID:that.$store.getters.User.enterprise.ID,
          sceneId: that.scene.ID,cSystemCode:'设施园艺'
        });
        that.deviceGFJSelectItems = res.data.obj.list;
        that.deviceJXGLQSelectItems = res.data.obj.list;
        that.deviceSBSelectItems = res.data.obj.list;
        that.deviceSBOSelectItems = res.data.obj.list;
        that.deviceZWXSelectItems = res.data.obj.list;
      },

      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntSceneMap/FindBySceneInfoID/' + that.scene.SceneInfoID, null)

        if (res.data.code == "200") {
          that.scene = res.data.obj.data;
            that.  sb1=  that.scene .sb1;
          that.        zxq1=  that.scene.zxq1;

            that.    sb2 =that.scene.sb2;
            that.    zxq2 =that.scene.zxq2;

            that.     sb3 =that.scene.sb3 ;
            that.     zxq3 =that.scene.zxq3;

            that.    sb4 =that.scene.sb4;
            that.     zxq4=  that.scene.zxq4;

            that.    sb5 =that.scene.sb5 ;
            that.    zxq5=that.scene.zxq5;



          that.    sb6 =that.scene.sb6 ;
          that.    zxq6=that.scene.zxq6;

          that.    sb7 =that.scene.sb7 ;
          that.    zxq7=that.scene.zxq7;

          that.    sb8 =that.scene.sb8 ;
          that.    zxq8=that.scene.zxq8;

          that.    sb9 =that.scene.sb9 ;
          that.    zxq9=that.scene.zxq9;

          that.    sb10 =that.scene.sb10 ;
          that.    zxq10=that.scene.zxq10;

          that.    sb11 =that.scene.sb11 ;
          that.    zxq11=that.scene.zxq11;

          that.    sb12 =that.scene.sb12 ;
          that.    zxq12=that.scene.zxq12;

          that.    sb13 =that.scene.sb13 ;
          that.    zxq13=that.scene.zxq13;

          that.    sb14 =that.scene.sb14 ;
          that.    zxq14=that.scene.zxq14;

          that.    sb15 =that.scene.sb15 ;
          that.    zxq15=that.scene.zxq15;


          that.     iTypeIDSelectId=that.scene.iTypeID;


          that. deviceSelect1(that.sb1);


        } else {

        }
      },
      onChange(_value){
        console.log('_value',_value);
        this.scene    .cEntCountry= _value[0];
        this.scene    .cEntCity=  _value[1];
        this.scene    .cEntArea=  _value[2];
      },
      SaveMapEvent(data){
        let that=this;
        that.scene.cLongitude=data.longitude;
        that.scene.cLatitude=data.latitude;
        that.geoshow=false;
      },
      changeCharge(){
        let that=this;
        let u= that.userList.filter(s=>s.ID==that.scene.cChargeUser)[0];
        if(u){
          that.scene.cChargeUser=u.cUserName;
          that.scene.cChargeMoblie=u.cMobile;
          that.scene.cChargeEmail=u.cEmail
        }

      },
      async handlePageList(){

      },
      //单位
      async handleunit(){


      },
      async handleclasschange(){

      },
      //设施园艺
      async handleariea(){


      },
      //获取用户列表
      async handlusers(){



      },

      toMapPage(record){
        let that=this;
        that.geoshow=true;

        that.address=record;
      },

      async SaveForms () {
        let that = this;
        let form=that.$refs['scene'];
        that.scene.sb1=   that.sb1;
        that.scene.zxq1=   that.zxq1;
        that.scene.sb2=   that.sb2;
        that.scene.zxq2=   that.zxq2;
        that.scene.sb3=   that.sb3;
        that.scene.zxq3=   that.zxq3;
        that.scene.sb4=   that.sb4;
        that.scene.zxq4=   that.zxq4;
        that.scene.sb5=   that.sb5;
        that.scene.zxq5=   that.zxq5;



        that.scene.sb6=   that.sb6;
        that.scene.zxq6=   that.zxq6;
        that.scene.sb7=   that.sb7;
        that.scene.zxq7=   that.zxq7;
        that.scene.sb8=   that.sb8;
        that.scene.zxq8=   that.zxq8;
        that.scene.sb9=   that.sb9;
        that.scene.zxq9=   that.zxq9;
        that.scene.sb10=   that.sb10;
        that.scene.zxq10=   that.zxq10;
        that.scene.sb11=   that.sb11;
        that.scene.zxq11=   that.zxq11;
        that.scene.sb12=   that.sb12;
        that.scene.zxq12=   that.zxq12;
        that.scene.sb13=   that.sb13;
        that.scene.zxq13=   that.zxq13;
        that.scene.sb14=   that.sb14;
        that.scene.zxq14=   that.zxq14;
        that.scene.sb15=   that.sb15;
        that.scene.zxq15=   that.zxq15;


        that.scene.iTypeID=   that.iTypeIDSelectId;
that.scene.SceneInfoID=   that.SceneInfoID;

        form.validate(async valid => {

          if (valid) {
            let res = await that.$http.post('EntSceneMap/Save', that.scene)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }

  }
</script>


